"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _url = _interopRequireDefault(require("./url"));
var _default = exports["default"] = {
  img_tag: function img_tag(src, alt, className, params) {
    src = _url["default"].img_url(src, params);
    return "<img src=\"" + src + "\" alt=\"" + escape(alt || '') + "\" class=\"" + escape(className || '') + "\" />";
  },
  script_tag: function script_tag(src) {
    return "<script src=\"" + src + "\" type=\"text/javascript\"></script>";
  },
  stylesheet_tag: function stylesheet_tag(href) {
    return "<link href=\"" + href + "\" rel=\"stylesheet\" type=\"text/css\" media=\"all\" />";
  }
};